export class Compania {
    public idCompania:string;
    public nombreCompania:string;
    public pais:string;
    public direccion:string;
    public logitud:string;
    public latitud:string;
    public telefono:string;
    public estado:string;
    public fechaVencimiento:any;
    public email:string; 
    public logo:string; 
}